export const OPEN_WAREHOUSE_MODAL = 'OPEN_WAREHOUSE_MODAL';
export const CLOSE_WAREHOUSE_MODAL = 'CLOSE_WAREHOUSE_MODAL';

export const CHANGE_WAREHOUSE = 'CHANGE_WAREHOUSE';

export const GET_WAREHOUSE = 'GET_WAREHOUSE';
export const GET_WAREHOUSE_SUCCESS = 'GET_WAREHOUSE_SUCCESS';
